import { BUSINESS_ADMIN_HOST } from 'api/constants';

export const GET_ALL_BUSINESS = `${BUSINESS_ADMIN_HOST}/v1/businesses`;
export const GET_BUSINESS_DETAILS = `${BUSINESS_ADMIN_HOST}/v1/businesses`;
export const OUTLET_URI = `${BUSINESS_ADMIN_HOST}/v1/outlets`;
export const RECURRING_PAYMENTS_URL = businessId =>
  `${BUSINESS_ADMIN_HOST}/v1/businesses/${businessId}/recurring-payments`;
export const RECURRING_PAYMENTS_HISTORY_URL = businessId =>
  `${BUSINESS_ADMIN_HOST}/v1/businesses/${businessId}/recurring-payments/all`;
export const RECURRING_PAYMENTS_TRANSACTIONS_URL = businessId =>
  `${BUSINESS_ADMIN_HOST}/v1/businesses/${businessId}/recurring-payments/transactions`;
